import styled from 'styled-components'

export const TableWrapper = styled.div` 
`

export const TableOptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr 200px;
  padding: 5px 0 30px 0;
`

export const DropdownItemInnerText = styled.div`
  margin: 0px 0px 0px 16px;

  font-weight: inherit;
  font-size: inherit;
`
